import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'

const RenderHTML = ({ htmlContent, variant, sx }) => {
  return (
    <Typography component="div" variant={variant} sx={sx}>
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </Typography>
  )
}

RenderHTML.propTypes = {
  htmlContent: PropTypes.string.isRequired,
  variant: PropTypes.string,
  sx: PropTypes.object,
}

export default RenderHTML
